import React from 'react';
import { useSelector } from 'react-redux';
import { useClientId } from '../../../../../../_hooks/useClientId';
import {
  selectHasPulseCheck,
  selectHasMobileNavigation,
} from '../../../../../../CommonSelectors/CommonAreaSelector';
import { GoalCardLoading } from '../GoalCard/GoalCard.loading';
import { GoalCardError } from '../GoalCard/GoalCard.error';
import { GoalCard } from '../GoalCard/GoalCard';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { usePulseCheckCardQuery } from '../../../../../api/usePulseCheckCardQuery';
import PulseCheckLogo from '../../../../../../PulseCheck/img/tile-logo.svg';

export const PulseCheckCard = () => {
  const hasPulseCheck = useSelector(selectHasPulseCheck);

  if (!hasPulseCheck) {
    return null;
  }

  return <Card />;
};

export const Card = () => {
  const { data, isLoading, error, refetch } = usePulseCheckCardQuery();

  const clientId = useClientId();

  const hasMobileNavigation = useSelector(selectHasMobileNavigation);

  if (isLoading) {
    return <GoalCardLoading />;
  }

  if (error) {
    return <GoalCardError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { IsCompleted, TopPriorities } = data;

  return (
    <GoalCard
      title="PulseCheck"
      icon={
        <PulseCheckLogo
          width={24}
          css={`
            color: ${({ theme }) => theme.colors.neutral['500']};
          `}
        />
      }
      ctaText={IsCompleted ? 'View Your Result' : 'Get Started'}
      showCompletedLozenge
      isCompleted={IsCompleted}
      hideFooter={hasMobileNavigation}
      onClick={() => {
        if (!hasMobileNavigation) {
          if (!IsCompleted) {
            ADV.util.Router.go2('PulseCheckWorkflow', { clientId });
          } else {
            ADV.util.Router.go2('PulseCheckResults', { clientId });
          }
        }
      }}
    >
      <>
        {!IsCompleted ? (
          <Text mb="auto">
            Discover the shape your fulfillment takes and how your financial plan can help you
            actualize it.
          </Text>
        ) : (
          <Box mb="auto">
            <Text fontWeight={600} mb="8">
              Top 3 Priorities
            </Text>

            <Box
              mb="8"
              as="ul"
              css="list-style: none; gap: 8px"
              p="0"
              display="flex"
              flexDirection="column"
              mt="8"
            >
              {TopPriorities.map((category, index) => (
                <Box key={category} as="li" display="flex" css="gap: 4px">
                  <Text>{`${index + 1}. ${category}`}</Text>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </>
    </GoalCard>
  );
};
